import React from 'react';
import { useData } from '../../context/DataContext';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

export const ParticipationKPIs = () => {
  const { getScopedStudents,participationCounts } = useData();
  const scoped = getScopedStudents();
  const total = participationCounts?.filter((item)=> item?.Grade === "Total")?.[0]?.Registered;
  // const total = scoped.length; 
  const participated = participationCounts?.filter((item)=> item?.Grade === "Total")?.[0]?.Participated;
  // const participated = scoped.filter(s => s.participated).length;
  const absent = participationCounts?.filter((item)=> item?.Grade === "Total")?.[0]?.Absent;
  // const absent = total - participated;

  const participationRate = total > 0 ? ((participated / total) * 100).toFixed(1) : '0';
  const absentRate = total > 0 ? ((absent / total) * 100).toFixed(1) : '0';

  const donutData = {
    labels: ['Participated', 'Absent'],
    datasets: [
      {
        data: [participationRate, absentRate],
        backgroundColor: ['#10B981', '#EF4444'],
        borderWidth: 4,
        borderColor: '#fff'
      }
    ]
  };

  const donutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom' },
      datalabels: { display: false }
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8 select-none">
      {/* Overall Participation Rate Card */}
      <div className="bg-white p-3 rounded-2xl shadow-lg border-2 border-gray-100 flex flex-col items-center justify-center">
        <h3 className="text-xl font-bold text-gray-800 mb-8 self-start m-0">Overall Participation Rate</h3>
        <div className="mini-chart-wrapper w-full mb-4" style={{ position: 'relative', height: '300px' }}>
          <Doughnut data={donutData} options={donutOptions} />
        </div>
      </div>

      {/* Participation Breakdown Card */}
      <div className="bg-white p-3 rounded-2xl shadow-lg border-2 border-gray-100">
        <h3 className="text-xl font-bold text-gray-800 mb-4">Participation Breakdown</h3>
        <div className="space-y-4">
          {/* Total Registered */}
          <div className="flex items-center justify-between p-2 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl border-l-4 border-blue-500">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center text-white">
                <span className="text-2xl">👥</span>
              </div>
              <div>
                <p className="font-bold text-gray-800 text-lg m-0">Total Registered</p>
                <p className="text-xs text-gray-600">Total enrollment</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-3xl font-bold text-blue-600">{total}</p>
            </div>
          </div>

          {/* Participated */}
          <div className="flex items-center justify-between p-2 bg-gradient-to-r from-green-50 to-green-100 rounded-xl border-l-4 border-green-500">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-green-500 rounded-xl flex items-center justify-center text-white">
                <span className="text-2xl">✅</span>
              </div>
              <div>
                <p className="font-bold text-gray-800 text-lg m-0">Participated</p>
                <p className="text-xs text-gray-600">Completed assessment</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-3xl font-bold text-green-600 m-0">{participated}</p>
              <p className="text-xs text-gray-600 font-bold">{participationRate}%</p>
            </div>
          </div>

          {/* Did Not Participate */}
          <div className="flex items-center justify-between p-2 bg-gradient-to-r from-red-50 to-red-100 rounded-xl border-l-4 border-red-500">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-red-500 rounded-xl flex items-center justify-center text-white">
                <span className="text-2xl">❌</span>
              </div>
              <div>
                <p className="font-bold text-gray-800 text-lg m-0">Did Not Participate</p>
                <p className="text-xs text-gray-600">Absent or no results</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-3xl font-bold text-red-600 m-0">{absent}</p>
              <p className="text-xs text-gray-600 font-bold">{absentRate}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ParticipationKPIs;
